import AbstractAPI from '../../common/AbstractAPI';
import { HTTPMethod } from '../../common/Constants';

class WhitelistRequestAPI extends AbstractAPI {
  static submitWhitelistRequest(
    claimantName,
    youtubeVideoUrl,
    youtubeChannelId,
    audioTrackUrl,
    audioTrackId,
    claimantOther
  ) {
    const options = this.buildFetchOptions(HTTPMethod.POST, {
      'claimant-name': claimantName,
      'youtube-url': youtubeVideoUrl,
      'youtube-channel-id': youtubeChannelId,
      'stock-item-url': audioTrackUrl,
      'stock-item-id': audioTrackId,
      'claimant-other': claimantOther,
    });

    return this.request('/api/member/youtube/submit', options);
  }
}

export default WhitelistRequestAPI;
